import { SignInViewModel }  from './xv-sign-in';
import { MLText, mlBroker } from '../../services/MLText';

export class SelectLangViewModel {
    Dismiss:   (pAction: () => void) => void;

    SignIn:     SignInViewModel;
    mlText:     MLText;
    app:        mlBroker;
    LangID:     number;
    LangHeader: string;

    constructor(
        pDismiss: (pAction: () => void) => void
    ) {
        this.Dismiss = pDismiss;
    }

    public Initialise(signIn: SignInViewModel) {
        this.SignIn = signIn;
        this.mlText = this.SignIn.mlText;
        this.app    = this.SignIn.app;

        this.LangID     = this.mlText.GetLangID();
        this.LangHeader = this.app.Text('Language' ,'Language');
    }

    public SelectLang(pLangID: number): void {
        this.Dismiss(() => {
            this.SignIn.ChangeLanguage(pLangID);
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/sign-in/xv-select-lang-popover.ts